<template>
  <div>
    <div
      style="
 
      "
      class="flex  justify-between items-center "
    >
      <div class="flex space-x-2 justify-start items-center">
        <div @click="reset()" class="global-button">
          <vk-icon icon="refresh" /><span>Sıfırla</span>
        </div>

        <select
          class="uk-select"
          style="width:150px"
          v-model="selectedTemplate"
        >
          <option value="0">Şablon seç</option>
          <option
            v-for="importedTemplate in importedTemplates"
            :value="importedTemplate.data"
            :key="importedTemplate.data"
          >
            {{ importedTemplate.name }}
          </option>
        </select>
        <span
          @click="templateFormOpen = !templateFormOpen"
          class="global-button"
        >
          <vk-icon icon="table" /> <span>Yeni Şablon</span>
        </span>
        <span @click="newLineFormOpen = true">
          <savebutton
            title="Yeni sutün"
            action="localUserColumnsAdd"
            icon="more"
          />
        </span>
      </div>

      <div @click="validate()" v-if="showValidateButton">
        <savebutton action="excelUpload" title="Yükle" icon="upload" />
      </div>
    </div>
    <table
      class="uk-table uk-table-hover uk-table-middle uk-table-divider tableScroll"
    >
      <tr>
        <th>
          Data
          <small>(ilk 4 satır önizleme için)</small>
        </th>
        <th>Düzenlenen Data</th>
        <th>Alan seçimi</th>
        <th>Durum</th>
        <th>Filtre</th>
      </tr>
      <tr class="tr" :key="index" v-for="(column, index) in localUserColumns">
        <td class="localuserColumns">
          <ul>
            <li :key="data" v-for="data in column.displayedData">
              <span>{{ data }}</span>
            </li>
          </ul>
        </td>
        <td>
          <template
            v-if="column.selection && fieldsMap[column.selection.value]"
          >
            <template
              v-if="fieldsMap[column.selection.value].filter == 'dateFixer'"
            >
              <ul>
                <li :key="index" v-for="(data, index) in column.displayedData">
                  <span>{{
                    data | dateFormat(column.selection.componentType)
                  }}</span>
                </li>
              </ul>
            </template>
          </template>
        </td>
        <th>
          <multiselect
            :id="index"
            v-model="column.selection"
            deselect-label
            :selected-label="text[lang].selected"
            :select-label="text[lang].select"
            track-by="name"
            label="name"
            :placeholder="text[lang].selectColumn"
            :options="column.options"
            :searchable="true"
            :allow-empty="false"
            @select="onSelectChange"
          ></multiselect>
        </th>

        <th>
          <template v-if="column.selection">
            <div class="flex space-x-2">
              <div class="check-div">
                <vk-icon icon="check" />
              </div>
              <template v-if="column.selection.value == 'phone'">
                <span
                  @click="doubleCheck(column.data)"
                  class="global-button-xs cursor-pointer"
                  >Double Kayıt Sayısı Çek</span
                >
              </template>
            </div>
          </template>
        </th>
        <th>
          <template
            v-if="column.selection && fieldsMap[column.selection.value]"
          >
            <template
              v-if="fieldsMap[column.selection.value].filter == 'dateFixer'"
            >
              <select
                v-model="column.selection.componentType"
                class="uk-select"
              >
                <option value="DD/MM/YY">DD/MM/YY</option>
                <option value="MM/DD/YY">MM/DD/YY</option>
                <option value="DD-MM-YY">DD-MM-YY</option>
                <option value="MM-DD-YY">MM-DD-YY</option>
                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                <option value="YYYY-DD-MM">YYYY-DD-MM</option>
                <option value="YYYY/DD/MM">YYYY/DD/MM</option>
                <option value="YYYY/MM/DD">YYYY/MM/DD</option>
              </select>
            </template>
          </template>
        </th>
      </tr>
    </table>

    <div class="fix"></div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>

    <vk-modal :stuck="true" :show.sync="templateFormOpen">
      <vk-modal-close ></vk-modal-close>
      <vk-modal-title>Yeni Şablon</vk-modal-title>

      <form @submit="templateSave()" action="javascript:void(0)" method="post">
        <div class="uk-margin">
          <label>Şablon ismi</label>
          <input type="text" v-model="templateFormName" class="uk-input" />
          <savebutton
            action="templateSave"
            style="margin-top: 10px"
            title="Kaydet"
          />
        </div>
      </form>
    </vk-modal>
    <vk-modal :stuck="true" :show.sync="newLineFormOpen">
      <vk-modal-close ></vk-modal-close>
      <vk-modal-title>Yeni Sutün</vk-modal-title>

      <form
        @submit="localUserColumnsAdd()"
        action="javascript:void(0)"
        method="post"
      >
        <div class="uk-margin">
          <label>Adı</label>
          <input type="text" v-model="newlocalcolumn.name" class="uk-input" />
        </div>
        <template v-if="localUserColumns[0]">
          <multiselect
            :id="99"
            v-model="newlocalcolumn.selection"
            deselect-label
            :selected-label="text[lang].selected"
            :select-label="text[lang].select"
            track-by="name"
            label="name"
            :placeholder="text[lang].selectColumn"
            :options="localUserColumns[0].options"
            :searchable="true"
            :allow-empty="false"
            @select="onSelectChange"
          >
          </multiselect>

          <template
            v-if="
              newlocalcolumn.selection &&
                fieldsMap[newlocalcolumn.selection.value]
            "
          >
            <template
              v-if="
                fieldsMap[newlocalcolumn.selection.value].component_id == 5 ||
                  fieldsMap[newlocalcolumn.selection.value].component_id == 10
              "
            >
              <div class="uk-margin">
                <label>{{
                  fieldsMap[newlocalcolumn.selection.value].display_name
                }}</label>
                <select v-model="newlocalcolumn.data" class="uk-select">
                  <option
                    v-for="option in this.$root.cache.getOptions[
                      fieldsMap[newlocalcolumn.selection.value].id
                    ]"
                    :value="option.value"
                    :key="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </template>
            <div v-else class="uk-margin">
              <label>Değer (bütün alanlarda aynı olacak)</label>
              <input
                type="text"
                v-model="newlocalcolumn.data"
                class="uk-input"
              />
            </div>
          </template>
        </template>

        <savebutton
          action="localUserColumnsAdd"
          style="margin-top: 10px"
          title="Kaydet"
        />
      </form>
    </vk-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Simplert from "vue2-simplert";
import _ from "lodash";
import text from "../lang";
import httpService from "../../../../services/http";
import moment from "moment";
import EventBus from "../../../Ui/EventBus";

export default {
  name: "ColumnChooser",
  components: { Multiselect, Simplert },
  props: {
    userColumns: {
      type: Array,
      required: true,
      validator: (columns) =>
        columns.every(
          (column) => _.has(column, "name") && _.has(column, "data")
        ),
    },
    columns: {
      type: Array,
      required: true,
      validator: (columns) =>
        columns.every(
          (column) => _.has(column, "name") && _.has(column, "value")
        ),
    },
    showValidateButton: {
      type: Boolean,
      default: () => true,
    },
    lang: {
      type: String,
      default: () => "en",
    },
  },
  filters: {
    dateFormat(val, type) {
      return moment(val, type).format("YYYY-MM-DD");
    },
  },
  watch: {
    userColumns(newColumns) {
      this.fillLocalUserColumns(newColumns);
    },
    selectedTemplate() {
      if (this.selectedTemplate !== 0) {
        this.templateLoad();
      }
    },
  },
  methods: {
    doubleCheck(data) {
      httpService.doubleCheck(data).then((e) => {
        if (e.data.result.match_count) {
          alert(
            "Eşleşen telefon sayısı : " +
              e.data.result.match_count +
              ", Toplam kayıt sayısı :" +
              e.data.total
          );
        }
      });
    },
    reset() {
      EventBus.$emit("fileResetExcel", "true");
    },
    localUserColumnsAdd() {
      let newData = [];

      EventBus.$emit("loadingStatus", {
        action: "localUserColumnsAdd",
        loading: true,
      });

      this.localUserColumns[0].data.map((e) => {
        newData.push(this.newlocalcolumn.data);
      });

      this.localUserColumns.push({
        name: this.newlocalcolumn.name,
        displayedData: _.take(newData, 4),
        data: newData,
        options: _.clone(this.columns),
        selection: this.newlocalcolumn.selection,
      });
      EventBus.$emit("loadingStatus", {
        action: "localUserColumnsAdd",
        loading: false,
        success: true,
      });

      this.newLineFormOpen = false;
    },
    onSelectChange({ value: selectedValue }, id) {
      // eslint-disable-line
      if (this.optionalValues.indexOf(selectedValue) !== -1) return;

      _.forEach(this.localUserColumns, (column, index) => {
        if (index !== id) {
          const hasSelectionConflict =
            column.selection && column.selection.value === selectedValue;
          if (hasSelectionConflict) {
            column.selection = null; // eslint-disable-line
          }
        }
      });
    },
    validate() {
      EventBus.$emit("loadingStatus", { action: "excelUpload", loading: true });

      const hasMadeAllSelections = true;

      if (!hasMadeAllSelections) {
        this.showError(text[this.lang].error.selectColumn); // eslint-disable-line
      } else {
        const selectedRequiredValues = _.map(
          this.localUserColumns,
          "selection.value"
        ).filter((value) => {
          if (value !== undefined) {
            return this.requiredValues.indexOf(value) !== -1;
          }
        });
        const missingValues = _.difference(
          this.requiredValues,
          selectedRequiredValues
        );

        if (missingValues.length > 0) {
          this.showError(
            `${text[this.lang].error.missingColumns} ${missingValues.join(
              ", "
            )}`
          ); // eslint-disable-line
          return;
        }

        this.results = this.localUserColumns.map((localColumn) => {
          if (localColumn.selection !== null) {
            if (localColumn.selection.componentType) {
              let ModifiedData = [];
              if (
                this.fieldsMap[localColumn.selection.value].filter ==
                "dateFixer"
              ) {
              }
              localColumn.data.forEach((localData) => {
                ModifiedData.push(
                  moment(localData, localColumn.selection.componentType).format(
                    "YYYY-MM-DD"
                  )
                );
              });

              return {
                column: localColumn.selection.value,
                data: ModifiedData,
                componentType: localColumn.selection.componentType,
              };
            } else {
              return {
                column: localColumn.selection.value,
                data: localColumn.data,
                componentType: localColumn.selection.componentType,
              };
            }
          }
        });

        this.$emit("on-validate", this.results);
      }
    },
    fillLocalUserColumns(newColumns) {
      this.localUserColumns = newColumns.map((column) => ({
        name: column.name,
        displayedData: _.take(column.data, 4),
        data: column.data,
        options: _.clone(this.columns),
        selection: null,
      }));
    },
    toggleHeaders() {
      if (this.withHeaders) {
        this.localUserColumns.forEach((column, index) => {
          const data = [column.name].concat(column.data);
          column.name = `${text[this.lang].column} ${index + 1}`; // eslint-disable-line
          column.data = data; // eslint-disable-line
          column.displayedData = _.take(column.data, 4); // eslint-disable-line
        });
      } else {
        this.localUserColumns.forEach((column) => {
          column.name = column.data.shift(); // eslint-disable-line
          column.displayedData = _.take(column.data, 4); // eslint-disable-line
        });
      }
      this.withHeaders = !this.withHeaders;
    },
    getTemplates() {
      httpService.getImportTemplates().then((resp) => {
        if (resp.data.success) {
          this.importedTemplates = resp.data.results;
        }
      });
    },
    templateSave() {
      EventBus.$emit("loadingStatus", {
        action: "templateSave",
        loading: true,
      });

      this.localUserColumns.map((e) => {
        this.templateFields.push(e.selection);
      });
      if (this.templateFields) {
        httpService
          .inlineSave({
            table: "import_templates",
            type: "insert",
            inputs: {
              name: this.templateFormName,
              data: JSON.stringify(this.templateFields),
              status: 1,
            },
          })
          .then((e) => {
            if (e.data.success) {
              EventBus.$emit("loadingStatus", {
                action: "templateSave",
                loading: false,
                success: true,
              });
              this.templateFormName = null;
              this.templateFormOpen = false;

              this.getTemplates();
            } else {
              this.$root.errorMessage(
                "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
              );
            }
          })
          .catch((e) => {
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
          })
          .finally((e) => {
            this.templateFormOpen = false;
          });
      }
    },
    templateLoad() {
      JSON.parse(this.selectedTemplate).map((selectedVal, index) => {
        this.localUserColumns[index].selection = selectedVal;
      });
    },
    showError(message) {
      this.$refs.simplert.openSimplert({
        title: text[this.lang].error.title,
        message,
        type: "error",
        customCloseBtnText: text[this.lang].close,
      });
    },
  },
  data() {
    return {
      withHeaders: true,
      localUserColumns: [],
      requiredValues: [],
      templateFormName: null,
      templateFormOpen: false,
      optionalValues: [],
      templateFields: [],
      selectedTemplate: 0,
      results: [],
      importedTemplates: [],
      fieldsMap: [],
      newLineFormOpen: false,
      newlocalcolumn: [],
      text,
    };
  },
  created() {
    httpService.fields(this.$route.params.table).then((resp) => {
      resp.data.map((field) => {
        this.fieldsMap[field.name] = field;
      });
      this.getTemplates();
    });
  },
  mounted() {
    this.fillLocalUserColumns(this.userColumns);
    this.optionalValues = this.columns
      .filter((column) => column.isOptional)
      .map((column) => column.value);
    this.requiredValues = this.columns
      .filter((column) => !column.isOptional)
      .map((column) => column.value);
  },
};
</script>
<style>
.fix {
  clear: both;
}

.tableScroll .tr {
  border-bottom: 1px solid #ddd !important;
}

.tableScroll .tr td,
.tableScroll .tr th {
  border-bottom: 1px solid #ddd !important;
}

.tableScroll .tr ul {
  margin: 0px;
  padding: 0px;
}

.tableScroll .tr ul li {
  display: block;
  font-size: 12px;
}

.localuserColumns {
  padding: 5px;
}

.check-div {
  background: rgb(44, 210, 44);
  color: rgb(255, 255, 255);
  text-align: center;
  display: flex;
  text-align: center;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 10px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
